<div id="print-section">
<div class="row">
  <div class="col-sm-3">
    <img vlink="image.png" [cache]="true" [model]="fourD.activeTeam" class="rounded-image-sm mr-2">
  </div>
  <div class="col-sm-9">
    <h1 mat-dialog-title>{{ 'MAP.INSPECTION_REPORT' | translate }}</h1>
  </div>
</div>
<div>
<span class="text-center">
  {{ 'MAP.REPORT_DATE' | translate }}: {{ getDateTime() | date: 'yyyy-MM-dd'}}
</span>
  <span class="spacer"></span>
  <div style="float: right">
  </div>
</div>
<!--<div>
  <mat-form-field >
    <mat-select [(value)]="noOfColumns" placeholder="No Of Columns">
      <mat-option [value]="i" *ngFor="let i of gridColumns">
        {{i}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>-->
<div>
  <p></p>
</div>
<div>

  <div>
    <mat-grid-list [cols]="noOfColumns" rowHeight="400px" gutterSize="1">
    <mat-grid-tile *ngFor="let data of data.model">

      <div class="text-inside-grid">

        <table width="500px">
          <tbody>
          <tr>
            <td>
              <h5> {{data.name}}</h5>
            </td>
          </tr>
          <tr>
            <td style="overflow:auto;">
              <div style="border:1px solid black;width: 500px; height: 200px;">
                <img *ngIf="data.screenshotName" style="width: 500px; height: 200px;"
                    [vlink]="data.screenshotName"
                    [model]="data">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="overflow:auto;">{{'MAP.DESC' | translate }}: {{ data.desc}}
              </div>
            </td>
          </tr>
          <tr>
            <td>{{'GENERIC.HEIGHT' | translate }}: {{ data.lheight}} 
              <br>
              {{'MAP.LATITUDE' | translate }}: {{ data.llat}} 
              <br>
              {{'MAP.LONGITUDE' | translate }}: {{ data.llng}}</td>
          </tr>
          <!-- <tr>
            <td>
              <textarea style="width:100%;height:270px;font-size:9px;">{{ data | json }}</textarea>
            </td>
          </tr> -->
          </tbody>
        </table>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
  </div>

</div>
<div>
  <button *ngIf="data.model.length > 0" mat-raised-button color="primary" class="mr-1" (click)="print()"> {{'MAP.PRINT' | translate }}
  </button>
  <button *ngIf="data.model.length > 0" mat-raised-button color="primary" class="mr-1" (click)="dialogRef.close()" >{{'GENERIC.CLOSE' | translate }}
</button>
</div>
</div>
